import React, { use, useEffect } from 'react';
import NavBar from './NavBar';
import '../styles/Header.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {

  useEffect(() => {
    const spinner = document.getElementById('spinner');
    if (spinner) {
      spinner.style.display = 'none';
      // Remove the show class to hide the spinner
      spinner.classList.remove('show');
    }
  }, []);
  return (
    <>
      <div id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>

      <div className="container-fluid sticky-top header-top bg-white shadow-sm" style={{ zIndex: 1030 }}>
        <div className="container d-flex align-items-center">
          <div className="d-flex align-items-center h-100">
            <Link to="/" className="navbar-brand" style={{ height: "70px" }}>
              <img src="img/logo-small.png" alt="Logo" />
            </Link>
          </div>
          <div className="w-100 h-100">
            <NavBar />
          </div>
        </div>
      </div>

      <div className="modal fade" id="searchModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Search by keyword</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body d-flex align-items-center bg-primary">
              <div className="input-group w-75 mx-auto d-flex">
                <input type="search" className="form-control p-3" placeholder="keywords"
                  aria-describedby="search-icon-1" />
                <span id="search-icon-1" className="btn bg-light border nput-group-text p-3"><i
                  className="fa fa-search"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
<div className='divider-line'></div>
    </>
  );
};

export default Header;
